function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14 7h-1V5c0-2.76-2.24-5-5-5S3 2.24 3 5v2H2C.9 7 0 7.9 0 9v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM5 5c0-1.66 1.34-3 3-3s3 1.34 3 3v2H5V5zm9 14H2V9h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z",
  fill: "#A16855"
});

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    fill: "none"
  }, props), _ref);
}

export default __webpack_public_path__ + "3ab416a240966229b9ee4cd65df21e64.svg";
export { SvgLock as ReactComponent };